<template>
  <transition name="dialog-fade">
    <div v-show="value">
      <div @click.self="close" class="dialog-wrap">
        <div class="dialog">
          <svg-icon size="24" pointer @click="close" name="cha"></svg-icon>
          <img :src="require(`@/common/img/${img}.png`)" alt />
          <div class="dialog__slot">
              <slot></slot>
            
          </div>
        </div>
      </div>
      <div class="dialog-mask"></div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    value: {},
    img:{
      default:'activeDialog'
    }
  },
  data() {
    return {
    
    }
  },
  methods: {
    close() {
      this.$emit("input", false)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  /* background:red; */
  /* overflow: auto;
    margin: 0; */
  position: fixed;
  z-index: 2020;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
      text-align: center;
}
.dialog-mask {
  position: fixed;
  z-index: 520;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // opacity: 0.5;
  background: rgba(0,0,0,0.3);;
  transition: .3s;
}
.dialog {
  /* height:400px; */
  /* width: 30%;   */
  background: rgba(0, 0, 0, 0);
  position: relative;
  margin: 0 auto 50px;
  margin-top: 15vh;
  display: inline-block;
  /* background: #fff; */
  border-radius: 2px;
  z-index: 2021;
  box-sizing: border-box;
  /deep/ .svgicon {
    position: absolute;
    right: 15px;
    top: 30px;
  }
}

.dialog__slot {
  position: absolute;
top: 40%;  width: 100%;
}

   
.dialog-fade-enter-active {
  animation: dialog-fade-in 0.3s;
  // transition:.3s;
}

.dialog-fade-leave-active {
  animation: dialog-fade-out 0.3s;
  // transition:.3s;
}

@keyframes dialog-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/certification/ActDialog.vue